import { AuthProvider } from 'react-admin';
import { fetchUtils } from 'react-admin';

import { config } from './config';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    const response = await fetch(`${config.apiUrl}/rpc/authenticate`, {
      method: 'POST',
      body: JSON.stringify({ username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    
    if (response.ok) {
      const { message, token } = await response.json();
      localStorage.setItem('auth', JSON.stringify({ token }));
      console.log("Authentication response:", message, token);
      return Promise.resolve();
    }
    const errorData = await response.json();
    console.error("Login error:", errorData);
    return Promise.reject();
  },
  
  logout: () => {
    localStorage.removeItem('auth');
    return Promise.resolve();
  },
  
  checkAuth: () => {
    return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject();
  },
  
  getPermissions: () => {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    if (!authData || !authData.token) return Promise.reject();
    return Promise.resolve();
  },

  getIdentity: () => {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    if (!authData || !authData.token) return Promise.reject();
    
    return Promise.resolve({ 
      id: authData.user_id,
      fullName: authData.email
    });
  },

  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      console.log('checkError 401/043 :', localStorage.getItem('auth'));
      localStorage.removeItem('auth');
      return Promise.reject();
    }
    console.log('checkError resolved:', localStorage.getItem('auth'));
    return Promise.resolve();
  }
};

// HTTP client that adds JWT auth header
export const httpClient = (url: string, options: any = {}) => {
  const authData = JSON.parse(localStorage.getItem('auth') || '{}');
  // console.log("Auth Data for httpClient:", authData);

  // Ensure headers object exists
  if (!options.headers) {
    options.headers = new Headers();
  }
  
  options.headers.set('Authorization', `Bearer ${authData.token}`);
  //console.log("Request Headers:", Object.fromEntries(options.headers));

  return fetchUtils.fetchJson(url, options);
};
